import { useEffect, useState } from "react";
import { api } from "./api";

/**
 * Fetches the backend build version once and stores it globally.
 * Also mirrors it into a <meta name="app-version"> tag so operators can
 * verify the running build from view-source without opening devtools.
 */
let _cached = null;

export const useAppVersion = () => {
  const [version, setVersion] = useState(_cached);

  useEffect(() => {
    if (_cached) return;
    let cancelled = false;
    api
      .get("/version")
      .then((r) => {
        const v = r?.data?.version || "";
        if (cancelled || !v) return;
        _cached = v;
        setVersion(v);
        // Mirror to <meta> for view-source inspection.
        try {
          let el = document.querySelector('meta[name="app-version"]');
          if (!el) {
            el = document.createElement("meta");
            el.setAttribute("name", "app-version");
            document.head.appendChild(el);
          }
          el.setAttribute("content", v);
        } catch (_) {
          /* no-op */
        }
      })
      .catch(() => {
        /* no-op — footer will simply omit the version */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return version;
};
